import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MusicalNoteIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.4 15.72C7 15.72 7.58 15.84 8.06 16.04V5.2L18.84 2.8V16.66C18.84 18.18 17.24 19.46 15.3 19.46C13.38 19.46 12.06 18.44 12.06 16.94C12.06 15.42 13.66 14.12 15.54 14.12C16.14 14.12 16.72 14.24 17.2 14.44V9.64L9.7 11.32V18.26C9.7 19.78 8.1 21.06 6.16 21.06C4.24 21.06 2.9 20.04 2.9 18.54C2.9 17.02 4.52 15.72 6.4 15.72ZM9.78 6.46V9.68L17.12 8.02V4.8L9.78 6.46ZM15.3 18.02C16.24 18.02 17.1 17.46 17.1 16.7C17.1 15.96 16.4 15.56 15.58 15.56C14.64 15.56 13.8 16.12 13.8 16.9C13.8 17.62 14.48 18.02 15.3 18.02ZM6.16 19.62C7.1 19.62 7.96 19.06 7.96 18.3C7.96 17.58 7.26 17.16 6.44 17.16C5.52 17.16 4.66 17.74 4.66 18.5C4.66 19.22 5.34 19.62 6.16 19.62Z" />
    </SvgIcon>
  );
});
